import * as storage from './storage'

export const getItem = (key: string) =>
	storage.getItem(key, window.sessionStorage)

export function removeItem(key: string) {
	storage.removeItem(key, window.sessionStorage)
}

export function setItem(key: string, value: unknown) {
	storage.setItem(key, value, window.sessionStorage)
}
